<template>
    <UserSearchList :isFavorite="isFavorite" @total-count="setTotalCount"/>
</template>
<script>

import UserSearchList from "@/components/user-search/UserSearchList.vue";
export default {
  name: "UserSearchFavorites",
  components: {
    UserSearchList,
  },
  props: {
    isFavorite: {
      type: Boolean,
      default: true,
    },
  },
  data() {
      return {
          totalCount: 0,
      };
  },
  methods: {
    setTotalCount(totalCount) {
        this.totalCount = totalCount;
        this.$emit('total-count', this.totalCount);
    },
  },
};

</script>
<style scoped lang="scss">
@import "~@/styles/rem";
@import "~@/styles/variables";

.user-search-favorites {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

#kitty {
  height: rem(400);
}
</style>
